import { createFileRoute } from "@tanstack/react-router";
import { AssessmentParent } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/assessment/parent/$sessionId")({
  head: () => seoHead({ title: "Parent Assessment", noindex: true }),
  component: AssessmentParent,
});
